import { SET_CURRENT_EDITED_BOOK, RESET_EDITED_BOOK } from './actionTypes'
import initialState from './initialState';

const editReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CURRENT_EDITED_BOOK:
            return { ...state, bookId: action.payload };
            
        case RESET_EDITED_BOOK:
            return  { ...state, bookId: undefined };
            
        default:
            return state;
    }
}

export default editReducer;